/** Tipos das Fases dos Funis de Vendas */
export interface FunilVendaFaseTipo {
    id: number;
    nome: string;
    nomePlural: string;
}

export const funilVendaFaseTipoQualificacao: FunilVendaFaseTipo = {
    id: 1,
    nome: 'Qualificação',
    nomePlural: 'Qualificações'
};
export const funilVendaFaseTipoOportunidade: FunilVendaFaseTipo = {
    id: 2,
    nome: 'Oportunidade',
    nomePlural: 'Oportunidades'
};
export const funilVendaFaseTipoQualificacaoOportunidade: FunilVendaFaseTipo = {
    id: 3,
    nome: 'Qualificação e Oportunidade',
    nomePlural: 'Qualificações e Oportunidades'
};
export const funilVendaFaseTipoPosVenda: FunilVendaFaseTipo = {
    id: 4,
    nome: 'Pós-Venda',
    nomePlural: 'Pós-Venda'
};

export const funilVendaFaseTipos: FunilVendaFaseTipo[] = [
    funilVendaFaseTipoQualificacao,
    funilVendaFaseTipoOportunidade,
    funilVendaFaseTipoPosVenda
];

/** Verifica se a Fase do Funil de Vendas é do tipo Qualificação */
export function isFunilVendaFaseTipoQualificacao(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === funilVendaFaseTipoQualificacao.id;
}

/** Verifica se a Fase do Funil de Vendas é do tipo Oportunidade */
export function isFunilVendaFaseTipoOportunidade(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === funilVendaFaseTipoOportunidade.id;
}

/** Verifica se a Fase do Funil de Vendas é do tipo Qualificação e Oportunidade */
export function isFunilVendaFaseTipoQualificacaoOportunidade(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === funilVendaFaseTipoQualificacaoOportunidade.id;
}


/** Verifica se a Fase do Funil de Vendas é do tipo Pós-Venda */
export function isFunilVendaFaseTipoPosVenda(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === funilVendaFaseTipoPosVenda.id;
}
